<template>
  <div
    class="candidate-portrait"
    :class="{ 'candidate-portrait-small': small }"
  >
    <div
      class="h-full w-full rounded-full border-solid pointer-events-none"
      :style="{
        'border-color': borderColor,
        borderWidth: small ? '0.15rem' : '0.218rem'
      }"
    >
      <lazy-image
        class="h-full w-full rounded-full object-cover"
        :src="
          candidate.urlImage ||
            require(`@/assets/images/genicon-candidate-unknown.svg`)
        "
        :style="{
          opacity: !showPosition || position > 0 ? 1 : 0.25
        }"
        v-fallback="require(`@/assets/images/genicon-candidate-unknown.svg`)"
        draggable="false"
      />
    </div>
    <img
      v-if="candidate.matchType === MatchType.Love"
      src="@/assets/icons/genicon-icons8-heart-filled-outline.svg"
      class="absolute candidate-status-icon bottom-0 right-0 pointer-events-none"
    />
    <icon-rejected
      v-if="candidate.matchType === MatchType.Dislike"
      class="absolute candidate-status-icon bottom-0 right-0 pointer-events-none text-interaction-dark"
    />
    <img
      v-if="showElected && candidate.elected"
      src="@/assets/icons/genicon-got-elected.svg"
      class="absolute candidate-status-icon bottom-0 left-0 pointer-events-none"
    />
    <icon-tick
      :count="teamPlaces"
      class="tick absolute top-0 left-0 pointer-events-none"
      style="width: auto;"
    ></icon-tick>
  </div>
</template>

<script>
import IconTick from "../icons/IconTick";
import { PartyColor } from "@/utils/PartyColor";
import { MatchType } from "@/utils/MatchType";
import LazyImage from "@/components/layouts/LazyImage";
import FallbackImg from "@/directives/FallbackImg";
import IconRejected from "@/components/icons/IconRejected";

export default {
  name: "CandidatePortrait",
  components: { IconRejected, LazyImage, IconTick },
  mixins: [PartyColor],
  directives: {
    fallback: FallbackImg
  },
  props: {
    candidate: {
      type: Object,
      required: true
    },
    small: {
      type: Boolean,
      default: false
    },
    /**
     * The candidate's position in the user's ranking
     */
    position: {
      type: Number,
      default: null
    },
    /**
     * Whether to show if this candidate is on the user's favorite list or not by making the portrait
     * less opaque if they're not
     */
    showPosition: {
      type: Boolean,
      default: true
    },
    /**
     * Whether to show if the candidate has been officially elected
     */
    showElected: {
      type: Boolean,
      default: true
    },
    /**
     * How many times the candidate has been placed on the list. (What list "the list" actually means can be defined
     * by the implementing context)
     */
    teamPlaces: {
      type: Number,
      default: 0
    }
  },
  data: () => {
    return {
      MatchType: MatchType
    };
  },
  computed: {
    borderColor() {
      return (
        this.candidate?.party?.color ||
        this.getPartyColor(this.candidate.partyId)
      );
    }
  }
};
</script>

<style scoped>
.candidate-portrait {
  position: relative;
  display: block;
  margin-left: auto;
  margin-right: auto;
  color: var(--color-regular);
  width: 4.125rem;
  height: 4.125rem;
}
.candidate-portrait-small {
  width: 2.6875rem;
  height: 2.6875rem;
}
.tick {
  left: 0.75rem;
  transform: translateX(-100%);
  height: 0.53125rem;
}
.candidate-portrait-small .tick {
  left: 0.48rem;
}
.candidate-status-icon {
  height: 1.25rem;
  font-size: 1.25rem;
}
.candidate-portrait-small .candidate-status-icon {
  height: 1rem;
  font-size: 1rem;
}
@media (min-width: 768px) {
  .candidate-portrait {
    width: 4.90625rem;
    height: 4.90625rem;
  }
  .candidate-portrait-small {
    width: 3.03125rem;
    height: 3.03125rem;
  }
  .tick {
    left: 1rem;
    height: 0.65625rem;
  }
  .candidate-portrait-small .tick {
    left: 0.57rem;
  }
  .candidate-status-icon {
    height: 1.5rem;
    font-size: 1.5rem;
  }
  .candidate-portrait-small .candidate-status-icon {
    height: 1.15rem;
    font-size: 1.15rem;
  }
}
</style>
